export const loginRequest = {
  scopes: ['User.Read', 'Calendars.Read', 'group.read.all']
};
